import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-feed-advice-router',
  templateUrl: './feed-advice-router.component.html',
  imports: [RouterOutlet],
})
export class FeedAdviceRouterComponent {
  constructor() {}
}
